module.exports = __webpack_public_path__ + "static/video-5b57aa2df7b765ba7e9da093488d6c54.mp4";